<template>
  <div class="xhu-login-page">
    <ComHeaderLeft class="xhu-login-header" />
    <div class="xhu-login-wrap">
      <img class="login-bg" src="../../static/images/login/bg.jpg" />
      <div class="login-content" id="axxLogin" />
    </div>
  </div>
</template>
<script>
// import { TOKEN_NAME } from '@/utils/constant'
import { TOKEN_NAME } from '@/utils/tools'
import ComHeaderLeft from '@/components/ComHeaderLeft'
import loginLogger from '@/utils/logger/login.js'
import cookies from '@/utils/cookies'

function loadScript(url) {
  // eslint-disable-next-line promise/param-names
  return new Promise((resolve, rejcet) => {
    const script = document.createElement('script')
    script.onload = function () {
      resolve()
    }
    script.onerror = function () {
      // eslint-disable-next-line prefer-promise-reject-errors
      rejcet()
    }
    script.src = url
    document.head.appendChild(script)
  })
}
export default {
  components: {
    ComHeaderLeft
  },
  data() {
    return {
      isReady: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    /**
 * 登录初始化
 * http://iwork.gaosiedu.com/pages/viewpage.action?pageId=122980285
 */
    async init() {
      const { redirect } = this.$route.query
      // 按顺序加载
      await loadScript('//q-fe.aixuexi.com/login/2.1.4/js/login.min.js')
      // eslint-disable-next-line
      let login = new Login({
        login: {
          mountId: 'axxLogin'
        },
        loginTitle: {
          1: {
            primary: '欢迎登录小括狐教师端',
            secondary: '请使用爱学习账号登录'
          }
        },
        loginSystem: 'ptxkhtpc', // 小括弧专用
        ptpcName: TOKEN_NAME,
        loginType: [1],
        loginErrorNum: 3,
        repeatVerifyType: 0,
        // 成功登录后的回调
        success (res) {
          // 清除 sessionStorage
          sessionStorage.clear()
          // cookies && cookies.setItem('userId', res.userId)
          // cookies && cookies.setItem('ptpc', res.axxProof)
          cookies && cookies.setItem('token', res.axxProof)
          // 有权限登录成功
          let toHref = '/'
          // 如果 有 redirect 并且不是登录页
          if (redirect && !/^(\/login)/.test(redirect)) {
            toHref = redirect
          }
          loginLogger.loginBtnLog()
          // 跳转到 redirect
          setTimeout(() => {
            location.href = toHref
          }, 0)
        },
        // 登录失败，webfunny 埋个点, 手机号脱敏发送 159****8888
        fail (err) {
          loginLogger.loginBtnLog()
          console.log(err)
        },
        // useCookie: false,
        // 请求体是否加密
        isRequestEncrypt: true,
        // 是否显示忘记密码
        isShowForgetPwd: false,
        // true cookie写入当前域名， false：cookie写入根域名
        standAlone: false,
        // 是否自动登录
        autoLogin: false,
        // 调用权限判断
        permission: () =>
          new Promise((resolve, reject) => {
            this.$service.login.getPermission()
              .then(({ buyPad }) => {
                if (buyPad) {
                  return resolve()
                }
                // 没权限
                // eslint-disable-next-line prefer-promise-reject-errors
                reject({
                  errorMessage: '该账号未开通该服务，请联系机构运营。'
                })
              })
              .catch(e => {
                let errobj = {
                  errorMessage: '登录失败'
                }
                if (e.errorMessage) {
                  errobj = e
                }
                reject(errobj)
              })
          })
      })
      login.trigger('start')
      // 大概等登录的 css 加载完再显示 logo
      setTimeout(() => {
        this.isReady = true
      }, 200)
    }
  }
}
</script>
<style lang="less" scoped>
.xhu-login-page {
  position: relative;
}
.xhu-login-header {
  position: relative;
  z-index: 2;
}
.xhu-login-wrap {
  position: relative;
  z-index: 1;
  display: flex;
  height: calc(100vh - 52px);
  background: #FFFFFF
}
.login-bg {
  height: 100%
}
// .xhu-login-wrap {
//   display: flex;
//   padding: 0 140px 0 100px;
//   align-items: center;
//   height: 100%;
//   background: #152A3A;
//   position: relative;
//   overflow: hidden;
//   > div {
//     position: relative;
//     z-index: 2;
//   }
//   .circle-bg {
//     position: absolute;
//     z-index: 1;
//     background: #1A354A;
//     border-radius: 50%;
//     &.circle-right {
//       width: 1260px;
//       height: 1260px;
//       top: -759px;
//       right: -883px
//     }
//     &.circle-left {
//       width: 1474px;
//       height: 1474px;
//       bottom: -1185px;
//       left: -482px;
//     }
//   }
// }
// .login-left {
//   flex: 1;
//   margin-right: 122px;
//   img {
//     width: 100%;
//   }
// }
// .login-content {
//   width: auto !important;
// }
</style>
<style lang="less">
.xhu-login-page {
  .system-name {
    font-weight: 700 !important;
    font-size: 40px !important;
    color: #303858 !important;
    margin: 0 !important;
  }
  .login-note {
    font-size: 14px !important;
    color: #505873 !important;
    margin: 16px 0 52px 0 !important;
  }
  .login-wrap, .login-btn, .login-username, .login-password {
    width: 430px !important;
  }
  .login-wrap {
    box-shadow: none !important;
  }
  .login-btn {
    background: #3262FD !important;
    margin: 0 !important;
    background: #FF6B00 !important;
    border-radius: 12px !important;
    height: 64px !important;
    font-weight: 700 !important;
    font-size: 20px !important;
  }
  .login-username, .login-password  {
    height: 48px !important;
    border-radius: 12px !important;
    border: 2px solid #EBEDF0 !important;
    box-sizing: border-box;
    padding: 12px 20px !important;
    font-size: 16px !important;
    color: #505873 !important;
    margin-bottom: 48px !important;
    ::placeholder {
      color: #98A2B2 !important;
    }
  }
  .login-username:focus,.login-username:hover,.login-password:focus,.login-password:hover {
    border: 1px solid #FF6B00 !important;
    padding: 13px 21px !important;
  }
  .login-username:focus,.login-password:focus,.login-tel:focus {
    box-shadow: 0px 0px 0px 3px rgba(253, 123, 50, 0.25) !important;
  }
  .error-tips {
    top: 240px !important;
    pointer-events: none;
  }
  .pass-message {
    padding: 0 !important;
  }
}

</style>
